import React from "react"
import { useNavigate } from "react-router-dom"
import { DASHBOARD } from "../../routes/CONSTANTS"
import { Button } from "@mui/material"
import { ReactComponent as AccessDenied } from "../../Assets/Logos/access-denied.svg"

const NotAuthorized = () => {
  const navigate = useNavigate()

  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[60vh] text-center p-6 bg-white rounded-xl border border-secondary-200">
      <AccessDenied />
      <h1 className="text-7xl font-bold text-secondary-900 m-0 leading-none">
        403
      </h1>
      <h2 className="text-2xl font-bold text-secondary-800 mt-4">
        Access Denied
      </h2>
      <p className="text-base text-secondary-500 mt-2 mb-8 max-w-md">
        You do not have the required permissions to access this page. Please
        contact your organization administrator if you believe this is an error.
      </p>
      <Button
        type="button"
        className="primaryButton"
        onClick={() => navigate(DASHBOARD)}
      >
        Back to Dashboard
      </Button>
    </div>
  )
}

export default NotAuthorized
